import { action, computed, observable } from "mobx";
import http, { getQuery } from "../service/http";
import qs from "qs";
import memberStore from "./member";

class Store {
  project = getQuery().project;
  lang = getQuery().lang;
  restaurantId = "";
  region = "";

  @action
  setUrl(restaurant) {
    const { id, region } = restaurant;
    this.restaurantId = id;
    this.region = region.id
  }

  /**获取收藏夹 */
  @action
  async list() {
    if (!memberStore.private_token) return [];
    try {
      const url = `/public/project/${this.project}/regions/${this.region}/collections`;
      let { data } = await http.get(url, {
        params: {
          lang: this.lang,
        },
        headers: {
          "X-Authorization": memberStore.private_token,
        },
      });
      return data;
    } catch (error) {
      console.error('获取收藏夹')
      return [];
    }
  }

  /**删除 */
  @action
  async remove(id) {
    try {
      const url = `/member/collections/${id}/items/destroy_restaurants`;
      let { data } = await http.delete(url, {
        params: {
          restaurant_ids_or_dirnames: this.restaurantId,
        },
        headers: {
          "X-Authorization": memberStore.private_token,
        },
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**新增 */
  @action
  async create(collection) {
    try {
      const url = `/public/member_collections`;
      let { data } = await http.post(
        url,
        {
          target_type: "Restaurant",
          target_id: this.restaurantId,
          id: collection.id,
        },
        {
          headers: {
            "X-Authorization": memberStore.private_token,
          },
        }
      );
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**判断 */
  @action
  async exist(collection) {
    try {
      const url = `/member/collections/favorite/restaurants/${this.restaurantId}/exist`;
      let { data } = await http.get(url, {
        headers: {
          "X-Authorization": memberStore.private_token,
        },
      });
      return data.exist;
    } catch (error) {
      console.error("判断是否收藏")
      return false;
    }
  }

  /**用户当前收藏夹 */
  @action
  async show() {
    try {
      const url = `/member/collections/favorite`;
      const { data } = await http.get(url, {
        params: {
          lang: this.lang,
        },
        headers: {
          "X-Authorization": memberStore.private_token,
        },
      });
      return data;
    } catch (error) {
      console.error("用户当前收藏夹")
      return null;
    }
  }
}

export default new Store();
